import { createTypedReducerWithImmer } from "@insite/client-framework/Common/CreateTypedReducer";
import BrandFormState from "@tCooneyBrothers/Store/Data/Brand/BrandState";
import { Draft } from "immer";

const initialState: BrandFormState = {
    isLoading: false
};

const reducer = {
    "Data/CustomBrandFormFields/BeginCustomBrandFormFields": (draft: Draft<BrandFormState>) => {
        draft = {
            isLoading: true,
        };
    },
    "Data/CustomBrandFormFields/CompletedCustomBrandFormFields": (draft: Draft<BrandFormState>) => {
        draft = {
            isLoading: false,
        };
    }
};

export default createTypedReducerWithImmer(initialState, reducer);
